import $ from "jquery";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm/js/jquery-confirm";

String.prototype.toCapitalize = function () {
  return this.toLowerCase()
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    })
    .join(" ");
};

/* replace the / after the profiles with %2F */
String.prototype.imageUrlDecode = function () {
  return this.replace("profiles/", "profiles%2F");
};

const getUrl = (param) => {
  let sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === param) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

const setCookie = (name, value, days) => {
  let date, expires;
  if (days) {
    date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  } else {
    expires = "";
  }

  document.cookie = name + "=" + value + expires + "; path=/";
};

const cookie = (param) => {
  let name = param + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const calcAdd = (lists) => {
  let total = 0;
  for (let list of lists) {
    total += list;
  }

  return total;
};

const toK = (val) => {
  let value = parseFloat(val);
  if (value >= 1000) {
    return value / 1000 + "k";
  } else {
    return value;
  }
};

const error = (title, content) => {
  $.confirm({
    title: title,
    content: content,
    icon: "fa fa-warning",
    closeAnimation: "scale",
    theme: "modern",
    closeIcon: true,
    animation: "scale",
    type: "red",
    buttons: {
      cancel: {
        isHidden: true,
      },
    },
  });
};

const success = (content) =>
  $.confirm({
    title: "Success",
    content: content,
    icon: "fa fa-thumbs-o-up",
    closeAnimation: "scale",
    theme: "modern",
    closeIcon: true,
    animation: "scale",
    type: "green",
    buttons: {
      ok: {
        isHidden: true,
      },
      cancel: {
        isHidden: true,
      },
    },
  });

const setSession = (name, value) => {
  sessionStorage.setItem(name, value);
};

const getSession = (name) => {
  return sessionStorage.getItem(name);
};

const removeSession = (name) => {
  sessionStorage.removeItem(name);
};

const changeDate = (param) => {
  return param.toDateString();
};

const changeTS = (param) => {
  return param.toDate().toDateString();
};

const toDateGet = (param) => {
  return param.toDate().getTime();
};

const dateGetTime = (param) => {
  return param.getTime();
};

const spaceRep = (param) => {
  let value = param.toString().trim();
  if (value.includes(" ")) {
    return value.replaceAll(" ", "-");
  } else {
    return value;
  }
};

const spaceAdd = (param) => {
  let value = param.toString().trim();
  if (value.includes("-")) {
    return value.replaceAll("-", " ");
  } else {
    return value;
  }
};

const lastIndexOfSplit = ({ text, split }) => {
  return text.split(split).at(-1);
};

const genStudentID = (students) => {
  let d = new Date();
  let value;
  let prefix = "0000";
  let year = d.toLocaleString("default", {
    year: "2-digit",
  });

  value = (students.length + 1).toString();
  return `SME-ST-${prefix.substring(value.length) + value}${year}`;
};

const getYear = () => {
  let date = new Date();
  return date.getFullYear();
};

const getMonth = () => {
  let date = new Date();
  return date.toLocaleString("default", {
    month: "long",
  });
};

const authErrors = ({ err }) => {
  switch (err) {
    case "auth/invalid-email":
      return {
        code: spaceAdd(
          lastIndexOfSplit({
            text: err,
            split: "/",
          })
        ).toCapitalize(),
        message:
          "The email address provided is invalid or not available!. Check and try again",
      };
    case "auth/user-not-found":
      return {
        code: "Invalid Email",
        message:
          "The email address provided is invalid or not available!. Check and try again",
      };
    case "auth/invalid-password":
      return {
        code: spaceAdd(
          lastIndexOfSplit({
            text: err,
            split: "/",
          })
        ).toCapitalize(),
        message:
          "The password entered is invalid or wrong or less than six letters!. Check and try again",
      };
    case "auth/wrong-password":
      return {
        code: spaceAdd(
          lastIndexOfSplit({
            text: err,
            split: "/",
          })
        ).toCapitalize(),
        message:
          "You have entered a wrong password for this user!. Check and try again",
      };
    case "auth/email-already-in-use":
      return {
        code: spaceAdd(
          lastIndexOfSplit({
            text: err,
            split: "/",
          })
        ).toCapitalize(),
        message:
          "The email address provided is already in use!. Try logging in.",
      };
    default:
      return {
        code: "Error",
        message: "Invalid credentials entered!. Check and try again",
      };
  }
};

/*Object.defineProperty(String.prototype, "toCapitalize", {
  value: function toCapitalize() {
    return this.toLowerCase()
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .map((word) => {
        return word[0].toUpperCase() + word.substring(1);
      })
      .join(" ");
  },
  writable: true,
  configurable: true,
});*/

export {
  setCookie,
  cookie,
  calcAdd,
  toK,
  success,
  error,
  setSession,
  getSession,
  removeSession,
  changeDate,
  changeTS,
  toDateGet,
  dateGetTime,
  spaceRep,
  getUrl,
  spaceAdd,
  lastIndexOfSplit,
  authErrors,
  genStudentID,
  getYear,
  getMonth,
};
